var _rect, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultAlbum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 268,
    viewBox: "0 0 268 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.505371,
    width: 267.495,
    height: 267.495,
    fill: "#C0C0C0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 134,
    r: 93,
    fill: "#C0C0C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.553 55.3929C90.8234 55.3929 55.3926 90.8237 55.3926 134.554C55.3926 178.284 90.8234 213.714 134.553 213.714C178.283 213.714 213.714 178.284 213.714 134.554C213.714 90.8237 178.283 55.3929 134.553 55.3929ZM83.4819 134.554H73.2676C73.2676 100.751 100.75 73.2679 134.553 73.2679V83.4822C106.4 83.4822 83.4819 106.4 83.4819 134.554ZM134.553 165.196C117.636 165.196 103.91 151.471 103.91 134.554C103.91 117.636 117.636 103.911 134.553 103.911C151.471 103.911 165.196 117.636 165.196 134.554C165.196 151.471 151.471 165.196 134.553 165.196ZM134.553 124.339C128.904 124.339 124.339 128.904 124.339 134.554C124.339 140.203 128.904 144.768 134.553 144.768C140.203 144.768 144.768 140.203 144.768 134.554C144.768 128.904 140.203 124.339 134.553 124.339Z",
    fill: "#969696"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAlbum);
export default __webpack_public_path__ + "static/media/DefaultAlbum.03cb662c814500b096011dac18721805.svg";
export { ForwardRef as ReactComponent };